import React from "react"
import { innerPageIframeStyle, fullPageIframeStyle } from "./styles"

export const PrivacyPolicyInner: React.FC = () => {
    return (
        <div
            style={{
                padding: "20px",
                flex: 1,
                display: "flex",
                flexDirection: "column" as const,
            }}>
            <iframe
                style={innerPageIframeStyle}
                src="https://aidocr.com/legal/privacy-policy.html"
                title="Privacy Policy"></iframe>
        </div>
    )
}

export const EULAInner: React.FC = () => {
    return (
        <div
            style={{
                padding: "20px",
                flex: 1,
                display: "flex",
                flexDirection: "column" as const,
            }}>
            <iframe
                style={innerPageIframeStyle}
                src="https://aidocr.com/legal/EULA.html"
                title="End User License Agreement"></iframe>
        </div>
    )
}

export const DisclaimerInner: React.FC = () => {
    return (
        <div
            style={{
                padding: "20px",
                flex: 1,
                display: "flex",
                flexDirection: "column" as const,
            }}>
            <iframe
                style={innerPageIframeStyle}
                src="https://aidocr.com/legal/disclaimer.html"
                title="Disclaimer"></iframe>
        </div>
    )
}

export const TermsOfUseInner: React.FC = () => {
    return (
        <div
            style={{
                padding: "20px",
                flex: 1,
                display: "flex",
                flexDirection: "column" as const,
            }}>
            <iframe
                style={innerPageIframeStyle}
                src="https://aidocr.com/legal/terms-of-use.html"
                title="Terms of Use"></iframe>
        </div>
    )
}

export const TermsOfUsePage: React.FC = () => {
    return (
        <iframe
            style={fullPageIframeStyle}
            src="https://aidocr.com/legal/terms-of-use.html"
            title="Terms of Use"></iframe>
    )
}

export const PrivacyPolicyPage: React.FC = () => {
    return (
        <iframe
            style={fullPageIframeStyle}
            src="https://aidocr.com/legal/privacy-policy.html"
            title="Privacy Policy"></iframe>
    )
}

export const DisclaimerPage: React.FC = () => {
    return (
        <iframe style={fullPageIframeStyle} src="https://aidocr.com/legal/disclaimer.html" title="Disclaimer"></iframe>
    )
}

export const EULAPage: React.FC = () => {
    return (
        <iframe
            style={fullPageIframeStyle}
            src="https://aidocr.com/legal/EULA.html"
            title="End User License Agreement"></iframe>
    )
}
